import { useShallow } from 'zustand/shallow';

import { store } from './store';

export const usePhotoSelection = () =>
  store(
    useShallow((state) => ({
      selectedIds: state.selectedIds,
      viewMode: state.viewMode,
      selectionMode: state.selectionMode,
      selectId: state.selectId,
      unSelectId: state.unSelectId,
      selectAll: state.selectAll,
      deselectAll: state.deselectAll,
      toggleViewMode: state.toggleViewMode,
      toggleSelectAll: state.toggleSelectAll,
    })),
  );
